/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ModerationInputs */

const en_moderation = /** @type {(inputs: ModerationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderation`)
};

const id_moderation = /** @type {(inputs: ModerationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderasi`)
};

/** @type {(inputs: ModerationInputs) => LocalizedString} */
const es_moderation = en_moderation;

/** @type {(inputs: ModerationInputs) => LocalizedString} */
const fr_moderation = en_moderation;

/** @type {(inputs: ModerationInputs) => LocalizedString} */
const de_moderation = en_moderation;

/** @type {(inputs: ModerationInputs) => LocalizedString} */
const ja_moderation = en_moderation;

/** @type {(inputs: ModerationInputs) => LocalizedString} */
const zh_moderation = en_moderation;

/** @type {(inputs: ModerationInputs) => LocalizedString} */
const ar_moderation = en_moderation;

/** @type {(inputs: ModerationInputs) => LocalizedString} */
const it_moderation = en_moderation;

/** @type {(inputs: ModerationInputs) => LocalizedString} */
const ru_moderation = en_moderation;

/** @type {(inputs: ModerationInputs) => LocalizedString} */
const pt_moderation = en_moderation;

/** @type {(inputs: ModerationInputs) => LocalizedString} */
const ko_moderation = en_moderation;

/**
* | output |
* | --- |
* | "Moderation" |
*
* @param {ModerationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const moderation = /** @type {((inputs?: ModerationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ModerationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderation(inputs)
	if (locale === "es") return es_moderation(inputs)
	if (locale === "fr") return fr_moderation(inputs)
	if (locale === "de") return de_moderation(inputs)
	if (locale === "ja") return ja_moderation(inputs)
	if (locale === "zh") return zh_moderation(inputs)
	if (locale === "ar") return ar_moderation(inputs)
	if (locale === "id") return id_moderation(inputs)
	if (locale === "it") return it_moderation(inputs)
	if (locale === "ru") return ru_moderation(inputs)
	if (locale === "pt") return pt_moderation(inputs)
	return ko_moderation(inputs)
});